import {
  API_END_POINT,
  axiosInstance,
  ENTITY_MANAGER_END_POINTS,
} from '@app-store'
export const fetchUsersForCase = async (
  program_id: string,
  permission_id: string
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}users/eligible-for-case-reassignment?programId=${program_id}&permissionId=${permission_id}`
  )
}

export const fetchTaskForAssignUnassign = async (
  caseId: string,
  workflowInstanceId: string
) => {
  return await axiosInstance.get(
    `${API_END_POINT.WORKFLOW}/${ENTITY_MANAGER_END_POINTS.CASE_MANAGEMENT}/${caseId}/get-tasks`,
    {
      params: {
        workflowInstanceId,
      },
    }
  )
}

export const caseCancelOrVoidApi = async (
  workflowInstanceId?: string,
  process = 'cancel' //or suspend for void
) => {
  return await axiosInstance.post(
    `${API_END_POINT.WORKFLOW}/${ENTITY_MANAGER_END_POINTS.PROCESS}/${workflowInstanceId}/${process}`
  )
}
